import { KeyedObject } from "types/root";

export const URLS: KeyedObject = {
  home: "/home/timeline",
  dashboardDeprecated: "/dashboard",
  login: "/login",
  forgotPassword: "/forgot-password",
  register: "/register",
  settings: "/settings",
  profileSettings: "/settings/profile",
  locationSettings: "/settings/location",
  projects: "/projects",
  projectDetail: "/projects/:project_guid/follower-chat",
  projectTeamChat: "/projects/:project_guid/team-chat",
  projectApps: "/projects/:project_guid/apps",
  projectAppsBlog: "/projects/:project_guid/apps/blog",
  projectAppsCalendar: "/projects/:project_guid/apps/calendar",
  projectAppsCalendarDEPRECATED: "/projects/:project_guid/calendar",
  projectLocation: "/projects/:project_guid/location",
  projectMembers: "/projects/:project_guid/members",
  projectAppsMailTODO: "/projects/:project_guid/apps/mail",
  projectAppsMail: "/projects/:project_guid/mail",
  projectCart: "/projects/:project_guid/cart",
  projectMarket: "/projects/:project_guid/market",
  projectEdit: "/projects/:project_guid/edit",
  projectTeam: "/projects/:project_guid/team",
  userMarket: "/market",
  userProjectInvitation: "/invitations/:member_guid",
  calendarApp: "/home/calendar",
  verifyCodePage: "/auth/:code_guid/code",
  verifyCodeResetPasswordPage: "/auth/:code_guid/reset-password",
  pageNotFound: "/page-not-found"
}

export const API_BASE_URL = import.meta.env.VITE_APP_API_URL;

export const COOKIE_DOMAIN = import.meta.env.VITE_APP_COOKIE_DOMAIN;

export const API_URLS: KeyedObject = {
  login: "/api/v1/auth-token/",
  signup: "/api/v1/signup/",
  verifyCode: "/api/v1/verify-code/:code_guid/",
  resendVerificationCodeWithGuid: "/api/v1/verify-code/:code_guid/resend/",
  resendVerificationCode: "/api/v1/verify-code-resend/",
  forgotPassword: "/api/v1/forgot-password/",
  resetPasswordUsingVerificationCode: "/api/v1/verify-code/:code_guid/reset-password/",
  locale: "/api/v1/data/locale/",
  saveLocale: "/api/v1/settings/locale/",
  saveProfile: "/api/v1/settings/profile/",
  siteSettings: "/api/v1/settings/site/",
  promotionSettings: "/api/v1/settings/promotions/",
  getSession: "/api/v1/data/session/",
  getCategories: "/api/v2/categories/",
  addProject: "/api/v2/projects/",
  editProject: "/api/v2/projects/:project_guid/edit/",
  publishProject: "/api/v2/projects/:project_guid/publish/",
  unpublishProject: "/api/v2/projects/:project_guid/unpublish/",
  getProject: "/api/v2/projects/:project_guid/",
  getProjects: "/api/v2/projects/",
  searchProjects: "/api/v1/projects/search/",
  getProjectMembers: "/api/v2/projects/:project_guid/members/",
  inviteProjectMember: "/api/v2/projects/:project_guid/members/",
  removeProjectMember: "/api/v2/projects/:project_guid/members/remove/",
  getProjectLocale: "/api/v2/projects/:project_guid/locale/",
  saveProjectLocale: "/api/v2/projects/:project_guid/locale/",
  getProjectCart: "/api/v1/projects/:project_guid/cart/:currency_guid/",
  getProjectMarketProducts: "/api/v1/projects/market-product/",
  getMyProjectMemberships: "/api/v1/projects/memberships/",
  getMyProjectInvitation: "/api/v1/projects/invitations/:member_guid/",
  acceptOrIgnoreInvitation: "/api/v1/projects/invitations/:member_guid/",
  search: "/api/v1/search/",
  getProfileSettings: "/api/v1/settings/profile/",
  getLocaleSettings: "/api/v1/settings/locale/",
  replyToProjectMessageDEPRECATED: "/api/v1/projects/:project_guid/messages/:post_id/reply/",
  replyToMessage: "/api/v1/messages/:post_id/reply/",
  postProjectMessage: "/api/v1/projects/:project_guid/messages/post/",
  getMyProjectMessages: "/api/v1/projects/messages/",
  followProject: "/api/v1/projects/:project_guid/follow/",
  unfollowProject: "/api/v1/projects/:project_guid/unfollow/",
  feedback: "/api/v1/feedback/",
  interactions: "/api/v1/interactions/"

}

export const APP_URLS: KeyedObject = {
  getApps: "/api/cms/v1/app/",
  addUserAppContent: "/api/cms/v1/app/user/:user_app_guid/content/",
  getUserAppContent: "/api/cms/v1/app/user/:user_app_guid/content/",
  addProjectApp: "/api/cms/v1/app/:app_guid/project/:project_guid/",
  addProjectAppContent: "/api/cms/v1/app/project/:project_app_guid/content/",
  getProjectAppContent: "/api/cms/v1/app/project/:project_app_guid/content/",
  editContent: "/api/cms/v1/app/content/:content_guid/",
  bulkDeleteUserAppContent: "/api/cms/v1/app/user/:user_app_guid/content/:parent_content_guid/bulk-delete/",
  bulkDeleteProjectAppContent: "/api/cms/v1/app/project/:project_app_guid/content/:parent_content_guid/bulk-delete/",
  bulkDeleteUserAppContentUser: "/api/cms/v1/app/user/:user_app_guid/content-user/bulk-delete/",
  bulkDeleteProjectAppContentUser: "/api/cms/v1/app/project/:project_app_guid/content-user/bulk-delete/",
  getMyContent: "/api/cms/v1/app/content/my/",

  getOrAddUserCartItems: "/api/economy/v1/cart/",
  removeUserCartItems: "/api/economy/v1/cart/:currency_guid/remove/",
  purchaseUserCartItems: "/api/economy/v1/cart/:currency_guid/buy/",
  cancelPurchaseOfUserCartItems: "/api/economy/v1/cart/:currency_guid/cancel/",
  confirmPurchaseOfUserCartItems: "/api/economy/v1/cart/:currency_guid/confirm/",

  getOrAddProjectCartItems: "/api/v1/projects/:project_guid/cart/:currency_guid/",
  removeProjectCartItems: "/api/v1/projects/:project_guid/cart/:currency_guid/remove/",
  purchaseProjectCartItems: "/api/v1/projects/:project_guid/cart/:currency_guid/buy/",
  cancelPurchaseOfProjectCartItems: "/api/v1/projects/:project_guid/cart/:currency_guid/cancel/",
  confirmPurchaseOfProjectCartItems: "/api/v1/projects/:project_guid/cart/:currency_guid/confirm/",
}

export const MONTHS: KeyedObject = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "Apri",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December",
}

export const INIT_DATA = {
  site: {
    savedTimestamp: 0,
    drawer: false,
    liveRegion: '',
  },
  locale: {
    countries: [],
    states: [],
    provinces: [],
    birthTowns: {
      isoCodeType__isoCode: [
        {
          value: 0,
          text: '',
        },
      ],
    },
    residentTowns: {
      isoCodeType__isoCode: [
        {
          value: 0,
          text: '',
        },
      ],
    },
    businessLocationTowns: {
      isoCodeType__isoCode: [
        {
          value: 0,
          text: '',
        },
      ],
    },
    savedTimestamp: 0,
  },
};

export const MENU_DATA = {
  "dashboard": {
    "id": "group-dashboard",
    "title": "home",
    "type": "group",
    "icon": "home",
    "children": [
      {
        "id": "home",
        "title": "home",
        "type": "collapse",
        "icon": "home",
        "url": URLS.home
      }
    ]
  }
}

export const FORMATS = {
  time: "h:mm A",
  time2: "HH:mm",
  date: "dddd, MMMM Do YYYY",
  date2: "MM/DD/YYYY",
  date3: "MMMM Do YYYY",
  date4: "MM/DD",
  date5: "YYYY-MM-DD",
}

export const CACHES = {
  promo: {
    name: "promoCacheCounter",
    total: 5,
  }
}


export const MIN_AGE_ALLOWED = 16;
export const MAX_AGE_ALLOWED = 120;

export const APPS: KeyedObject = {
  calendar : {
    shortName: "calendar",
    url: URLS.projectAppsCalendar,
  },
  blog: {
    shortName: "blog",
    url: URLS.projectAppsBlog,
  },
}
